import withSharedStyles from "../theme/Shared.style";

// SEO directory under the home page: value props, category / brand name
// lists and useful links, styled as a quiet surface panel.
const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, fontSize } = theme.tokens;
  return {
    root: {
      marginTop: 8,
      padding: "32px !important",
      borderRadius: `${radius.card}px !important`,
      backgroundColor: `${color.surface} !important`,
      color: color.text2,
      fontSize: fontSize.ui,
      "& .MuiTypography-body1": { fontSize: fontSize.body, color: color.ink },
      "& .MuiTypography-body2": {
        fontSize: fontSize.small,
        color: color.muted
      },
      "& a": { color: color.text2, textDecoration: "none" },
      "& a:hover": { color: color.brandText },
      [theme.media.phone]: { padding: "20px !important" }
    },
    mainRow: {
      paddingBottom: 8
    },
    categoriesContainer: {
      overflowX: "auto",
      paddingTop: 12,
      ["@media (min-width:365px)"]: { maxHeight: 1300 },
      [theme.media.tabletUp]: { maxHeight: 1000 },
      [theme.media.desktop]: { maxHeight: 800 }
    },
    brandsContainer: {
      paddingTop: 12
    },
    categoryTitle: {
      fontSize: `${fontSize.title}px !important`,
      fontWeight: "800 !important",
      color: `${color.ink} !important`
    },
    captionH5: {
      paddingBottom: 12,
      fontWeight: 800
    },
    mobileOnly: {
      [theme.media.tabletUp]: { display: "none" }
    },
    categorySection: {
      paddingTop: 16
    }
  };
});

export default withCustomStyles;
